export default __webpack_public_path__ + "static/artisan-pc-d8b6a0d8f81e69f61876d8b1d05c37bc.jpg";